import Request from './request';

async function tree(data) {
    return Request('get', "api/material-show-categories/tree", data);
}

export default {
  tree,
}